import { translate, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Component, Mixins } from 'vue-property-decorator';

var KeycloakLoginExpired = /** @class */ (function (_super) {
    __extends(KeycloakLoginExpired, _super);
    function KeycloakLoginExpired() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(KeycloakLoginExpired.prototype, "summary", {
        get: function () {
            var _a, _b, _c;
            var isTranslationExists = translate("keycloak.corex.error." + ((_a = this.kcContext.message) === null || _a === void 0 ? void 0 : _a.type)) !== '';
            return isTranslationExists
                ? translate("keycloak.corex.error." + ((_b = this.kcContext.message) === null || _b === void 0 ? void 0 : _b.type))
                : (_c = this.kcContext.message) === null || _c === void 0 ? void 0 : _c.summary;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KeycloakLoginExpired.prototype, "backToLoginUrl", {
        get: function () {
            return window.location.origin + this.kcContext.url.loginRestartFlowUrl;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop(Object),
        __metadata("design:type", Object)
    ], KeycloakLoginExpired.prototype, "kcContext", void 0);
    KeycloakLoginExpired = __decorate([
        Component({
            name: 'corex-keycloak-login-expired',
        })
    ], KeycloakLoginExpired);
    return KeycloakLoginExpired;
}(Mixins(MagicConfigMixin)));

export default KeycloakLoginExpired;
